import { configureStore } from '@reduxjs/toolkit'
import botEvents from './modules/bot-events'
import progress from './modules/progress'
import storage from './modules/storage'
import user from './modules/user'
import botView from './modules/bot-view'
import webchat from './modules/webchat'

export const reduxStore = configureStore({
  reducer: {
    botEvents,
    progress,
    storage,
    user,
    botView,
    webchat,
  },
})

export type RootState = ReturnType<typeof reduxStore.getState>
export type AppDispatch = typeof reduxStore.dispatch
